import axios from 'axios'
import {DownloadUtils} from '@/core/utils'

const downloadUtils = new DownloadUtils()

class FileManagerApiClient {


    async uploadArquivo(dados) {
        const formData = new FormData()
        formData.append('nomeArquivo', dados.nomeArquivo)
        formData.append('arquivo', dados.arquivo)
        formData.append('repositorio', dados.repositorio)
        await axios.post('/filemanager/upload', formData)
    }

    async baixarArquivo(dados) {
        const response = await axios.get(`/filemanager/download?uri=${dados.url}`, {responseType: 'blob'})
        let nome = dados.nome ? dados.nome : dados.url
        downloadUtils.baixarBlob(response.data, nome, response.data.type)
    }

}

export default new FileManagerApiClient()
